<div class="d-flex flex-wrap" *ngIf="selected!=-1">
  <label class="badgebadge badge-pill fs-xs mx-1 border pointer" *ngFor="let shortcut of shortcuts;let index=index"
    [class.gray-bg]="selected==index" [class.f-white]="selected==index" (click)="selectShortcut(index)">{{shortcut.title}}</label>
  <label class="badgebadge badge-pill fs-xs mx-1 border pointer" (click)="selected=-1">...</label>
</div>
<div class="d-flex " *ngIf="selected==-1">
  <label *ngIf="shortcuts?.length" class="badge badge-pill border pointer ml-2" (click)="selectShortcut(undefined)">
    <i _ngcontent-pishkar-c140="" class="fa fa-arrow-up pointer"></i></label>
  <input type="time" class="form-control px-1 ml-2" [(ngModel)]="pdate.time" *ngIf="mode.includes('time')" />
  <select class="text-center form-control fs-sm" [(ngModel)]="pdate.day" *ngIf="mode.includes('day')"
    [class.f-gray]="!pdate.day" [required]="required || isPartial ? 'required': undefined"
    [disabled]="_disabled ? 'disabled' : undefined">
    <option [ngValue]="undefined" disabled selected hidden>روز</option>
    <option *ngFor="let d of days" [ngValue]="+d">{{d}}</option>
  </select>
  <select class="text-center  form-control fs-sm" [(ngModel)]="pdate.month" *ngIf="mode.includes('month')"
    [required]="required || isPartial ? 'required': undefined" [class.f-gray]="!pdate.month"
    [disabled]="_disabled ? 'disabled' : undefined">
    <option [ngValue]="undefined" disabled selected hidden>ماه</option>
    <option *ngFor="let m of PersianDate.MonthNameList;let mi=index" [ngValue]="mi+1">{{m}}</option>
  </select>
  <select class="text-center  form-control fs-sm" [(ngModel)]="pdate.year" *ngIf="mode.includes('year')"
    [required]="required || isPartial ? 'required': undefined" [class.f-gray]="!pdate.year"
    (mousedown)="onmousedown($event)" [disabled]="_disabled ? 'disabled' : undefined">
    <option [ngValue]="undefined" disabled selected hidden>سال</option>
    <ng-container *ngFor="let y of years">
      <optgroup *ngIf="y%10==0"></optgroup>
      <option [ngValue]="y">{{y}}</option>
    </ng-container>
  </select>
  <!-- <input class="text-center mr-2 form-control px-1" dir="ltr" type="text" inputmode="numeric" kp-numeric min="1300"
    max="1500" [required]="required || isPartial ? 'required': undefined" pattern="1[34]\d{2}" [(ngModel)]="pdate.year"
    placeholder="سال" *ngIf="mode.includes('year')" [disabled]="_disabled ? 'disabled' : undefined" /> -->
</div>